import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

interface IonSelectOption {
  value: any;
  label: string;
}

interface IonSelectProps extends FormlyFieldProps {
  options?: IonSelectOption[];
  placeholder?: string;
  labelPlacement?: string;
  interface?: string;
}

@Component({
  selector: 'formly-field-ion-select',
  standalone: true,
  templateUrl: './custom-ion-select.component.html',
  styleUrls: ['./custom-ion-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, IonicModule],
})
export class CustomIonSelectComponent extends FieldType<FieldTypeConfig<IonSelectProps>> {

  constructor(protected translocoService: TranslocoService) {
    super();
  }

  get selectOptions(): IonSelectOption[] {
    return this.props.options || [];
  }

  override get showError(): boolean {
    return (
      !!this.formControl &&
      this.formControl.invalid &&
      (this.formControl.touched ||
        (this.options.parentForm as any)?.submitted)
    );
  }

  get errorMessage(): string | null {
    if (!this.formControl?.errors) return null;
    return this.translocoService.translate('FORMLY.ERROR.FIELD_REQUIRED');
  }
}